import React from "react";

export default function DealRisks({ dealRisks }) {
  if (!dealRisks || dealRisks.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 32 }}>
      <h2>⚠️ AI Deal Risks</h2>

      <div style={riskGridStyle}>
        {dealRisks.map((risk, index) => (
          <div
            key={index}
            style={
              risk.severity === "High"
                ? riskCardHighStyle
                : riskCardMediumStyle
            }
          >
            <h3 style={{ marginTop: 0 }}>
              {risk.icon} {risk.company}
            </h3>

            <p>
              <b>Severity:</b> {risk.severity}
            </p>

            <p>{risk.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const riskGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16
};

const riskCardHighStyle = {
  padding: "16px",
  borderRadius: "12px",
  background: "#fee2e2",
  border: "1px solid #fecaca",
  color: "#7f1d1d"
};

const riskCardMediumStyle = {
  padding: "16px",
  borderRadius: "12px",
  background: "#fef3c7",
  border: "1px solid #fde68a",
  color: "#78350f"
};